import { useLocation } from "react-router-dom";
import { unAuthPath, publicPath } from "@/utils/base";
import { getAuthTokenValue } from "@kaihong/utils/lib/khAuthToken";
import { goLogin } from "@/utils";
const UserStatusComponent = (params: { children: any }) => {
  const location = useLocation();
  const { pathname } = location;
  const children = params.children;
  // console.log('location', location);
  const Authorization = getAuthTokenValue("Authorization");
  // 拦截旧的登录路由，直接重定向到统一登录平台，避免页面闪烁
  if (pathname === `${publicPath}/login` || pathname === `/login`) {
    goLogin();
    return <></>;
  }
  if (Authorization || unAuthPath.some((path) => pathname === path)) {
    // if (getAuthTokenValue("Authorization") || isPathAllowed(pathname, unAuthPath)) {
    return <>{children}</>;
  } else {
    // 跳转至登录页面
    goLogin();
    return <></>;
  }
};
export { UserStatusComponent };
